export default __webpack_public_path__ + "static/media/tcis.b46de4a5.png";